import React from "react";
import {DrmInformationHooks} from "@/types/drmInformation";
import {useDrmInformationSearch} from "@/stores/drmInformationSearch";

export const SearchConditionContainer = ({drmInformationHooks}: { drmInformationHooks: DrmInformationHooks }) => {
  const {
    searchText, setSearchText,
    searchYear, setSearchYear,
  } = useDrmInformationSearch()

  function getYearOptions() {
    const yearList = [];
    const current = (new Date().getFullYear());
    const stop = 2;
    for (let i = current; i > current - stop; i--) {
      yearList.push(i);
    }
    return yearList;
  }

  return (
    <div className="drmInformation-search-condition uk-margin-top">
      <div className="uk-flex">
        <div className="uk-flex-1 uk-flex-column">
          <div className="uk-flex uk-flex-middle">
            <span className="uk-width-small">キーワード</span>
            <input
              className="input-search uk-width-1-2"
              onChange={event => setSearchText(event.target.value)}
              value={searchText}
            />
          </div>
          <div className="uk-flex uk-flex-middle uk-margin-small-top">
            <span className="uk-width-small">年度</span>
            <select
              className="input-search uk-width-1-2"
              onChange={event => setSearchYear(event.target.value)}
              value={searchYear}
            >
              <option value={""}>-- 選択してください --</option>
              {getYearOptions().map((value: number) => {
                return (<option value={value}>{value}</option>);
              })}
            </select>
          </div>
          <div className="uk-flex uk-flex-middle uk-margin-small-top">
            <span className="uk-width-small">情報区分</span>
            <div className="uk-flex uk-flex-wrap">
              {drmInformationHooks.conditionList?.drm_information_types?.map((type, index) => (
                <label
                  key={index}
                  className="width-160"
                >
                  <input
                    type="checkbox"
                    onChange={() => drmInformationHooks.onClickCheckType(type.code)}
                    checked={drmInformationHooks.checkTypeCodes.includes(type.code)}
                  />
                  {type.option}
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="uk-flex uk-flex-bottom">
          <button className="button-search margin-left-32" onClick={drmInformationHooks.onClickSearch}>検索</button>
        </div>
      </div>
    </div>
  )
}